import React from 'react'
import Header from './components/Header'
import Profiles from './components/Profiles'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => {
    return {
        container: {
            margin: 'auto',
            minHeight: '90vh',
        },
    }
})

function Candidates() {
    const classes = useStyles()
    return (
        <div className={classes.container}>
            <Header />
            <Profiles />
        </div>
    )
}

export default Candidates
